export const actions = {
  navigate({ commit }, newRoute) {
    commit('navigate', newRoute);
  },
  toggleDrawer({ commit }, newState) {
    commit('toggleDrawer', newState);
  },
  toggleDrawerLoading({ commit }, newState) {
    commit('toggleDrawerLoading', newState);
  },
  updateProviders({ commit }, providers) {
    commit('updateProviders', providers);
  },
  previousProvider({ commit, state }) {
    const currentProviderIndex = state.providers.findIndex(p => p.path === state.currentPath);
    if (currentProviderIndex > 0) {
      commit('navigate', state.providers[currentProviderIndex - 1]);
    } else {
      commit('navigate', state.providers[state.providers.length - 1]);
    }
  },
  nextProvider({ commit, state }) {
    const currentProviderIndex = state.providers.findIndex(p => p.path === state.currentPath);
    if (currentProviderIndex < state.providers.length - 1) {
      commit('navigate', state.providers[currentProviderIndex + 1]);
    } else {
      commit('navigate', state.providers[0]);
    }
  },
};

export const mutations = {
  navigate(state, { path, day, provider }) {
    state.currentPath = path;
    state.currentDay = day;
    state.currentProvider = provider;
  },
  updateProviders(state, providers) {
    state.providers = providers;
  },
  toggleDrawer(state, newState) {
    if (newState !== undefined) {
      state.drawerOpen = newState;
    } else {
      state.drawerOpen = !state.drawerOpen;
    }
  },
  toggleDrawerLoading(state, newState) {
    if (newState !== undefined) {
      state.drawerLoading = newState;
    } else {
      state.drawerLoading = !state.drawerLoading;
    }
  },
};

export const getters = {
  currentRoute(state) {
    let pathName = state.currentPath.startsWith('/dishes') ? state.currentDay : '';
    if (!pathName) {
      const activeOption = [...state.drawerItems.optionsItems, ...state.drawerItems.bottomItems]
        .find(i => state.currentPath.startsWith(i.path));
      if (activeOption) {
        pathName = activeOption.id;
      }
    }

    return {
      path: state.currentPath,
      day: state.currentDay,
      provider: state.currentProvider,
      isDishesOverview: state.currentPath.startsWith('/dishes'),
      name: pathName,
    };
  },
  dailyLunchItems(state) {
    return state.drawerItems.dailyLunchItems;
  },
  optionsItems(state) {
    return state.drawerItems.optionsItems;
  },
  isDrawerOpen(state) {
    return state.drawerOpen;
  },
  isDrawerLoading(state) {
    return state.drawerLoading;
  },
  bottomItems(state) {
    return state.drawerItems.bottomItems;
  },
};

export const state = {
  currentPath: '',
  currentDay: '',
  currentProvider: '',
  drawerOpen: true,
  drawerLoading: false,
  providers: [],
  drawerItems: {
    optionsItems: [
      {
        icon: 'mode_edit', path: '/edit', id: 'lunchEditing', admin: true,
      },
      // Deprecated: Users Expenses page
      // {
      //   icon: 'monetization_on', path: '/monthlyExpenses', id: 'monthlyExpenses', admin: true,
      // },
      {
        icon: 'savings', path: '/usersBalances', id: 'usersBalances',
      },
      { icon: 'history', path: '/ordersHistory', id: 'ordersHistory' },
      { icon: 'list', path: '/ordersList', id: 'ordersList' },
      {
        icon: 'restaurant_menu', path: '/ordersCounts', id: 'ordersCounts', admin: true,
      },
      { icon: 'star', path: '/ratings', id: 'dishesRatings' },
    ],
    bottomItems: [
      { icon: 'settings', path: '/settings', id: 'settings' },
      { icon: 'exit_to_app', path: '/logout', id: 'signOut' },
    ],
  },
};

export const drawerStore = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
